export class Session {
  login: boolean;
  user: any;
  loading: boolean;
  opened: boolean;
  googleAuth: boolean;
  token: string;
  personalSetting: any;
  customerId: string;
  nabelAdmin?: boolean;
  customerAdmin?: boolean;
  passwordUpdated: boolean;

  constructor() {
    this.login = false;
    this.loading = false;
    this.opened = true;
    this.googleAuth = false;
    this.token = '';
    this.customerId = '';
    this.passwordUpdated = false;
  }

  /**
   *
   */
  reset(): void {
    // 追加
    this.login = false;
    this.loading = false;
    this.user = null;
    this.googleAuth = false;
  }
}
